import * as React from 'react'
import styled from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'

import * as entities from '@boutique/entities'

import { useProductListing } from '../hooks/useProductListing'
import { Total } from './Total'

export function Sort(): React.ReactElement {
  const defaultOption = entities.search.SORT_OPTIONS[0]

  const {
    query: { sort },
    setSort,
    apply,
  } = useProductListing()

  const selectedOption = entities.search.SORT_OPTIONS.find((option) => option.value === sort) ?? defaultOption
  const selected = [selectedOption.value]

  return (
    <SortWrapper hasSelection={selected.length > 0}>
      <Total />
      <SortSelect
        mode="inline"
        hasSelection={selected.length > 0}
        onChange={(selection) =>
          apply(setSort(selection[0].value === defaultOption.value ? undefined : selection[0].value))
        }
        selected={selected}
        native={true}
        label={(selected) => {
          return (
            <Label>
              <plume.glyphs.stroke.Sort size={18} />
              <TrueLabel>{selected[0]?.label ?? ''}</TrueLabel>
              <FakeLabel>Trier</FakeLabel>
            </Label>
          )
        }}
      >
        {entities.search.SORT_OPTIONS.map((sortOption) => (
          <plume.Option native={true} key={sortOption.value} value={sortOption.value} label={sortOption.label}>
            {sortOption.label}
          </plume.Option>
        ))}
      </SortSelect>
    </SortWrapper>
  )
}

const TrueLabel = styled.span`
  display: none;
  @media screen and ${plume.BREAKPOINTS.TABLET} {
    display: inline;
  }
`

const FakeLabel = styled.span`
  display: inline;
  @media screen and ${plume.BREAKPOINTS.TABLET} {
    display: none;
  }
`

const Label = styled.span`
  ${plume.glyphs.stroke.Sort} {
    display: none;
  }

  @media not screen and ${plume.BREAKPOINTS.TABLET} {
    ${plume.styles.copy._smallStyle};
    color: ${plume.COLORS.GREY_SHADE_1};

    ${plume.glyphs.stroke.Sort} {
      color: ${plume.COLORS.GREY_SHADE_7};
      margin-right: 6px;
      display: inline-block;
    }
  }
`

const SortSelect = styled(plume.Dropdown)<{ hasSelection: boolean }>`
  ${plume.styles.select.Drawer} {
    left: unset;
    right: 0px;
  }

  @media not screen and ${plume.BREAKPOINTS.TABLET} {
    width: 100%;
    height: 100%;

    ${plume.styles.select.DrawerHead} {
      background: white;
      display: flex;
      padding: 0 22px;
      justify-content: space-between;

      ${plume.glyphs.stroke.Sort} {
        width: 24px;
        height: 24px;
      }

      ${FakeLabel} {
        ${plume.styles.heading._xxSmallStyle}
      }

      ${plume.styles.button.Base} {
        padding: 0;
        height: auto;
      }
    }

    ${plume.styles.select.Button} {
      cursor: pointer;
      pointer-events: none;
      border: none;
      font-family: ${plume.FONTS.PRIMARY_FONT};
      font-weight: 900;
      text-transform: uppercase;
      padding: 10px 40px;
      display: inline-flex;
      justify-content: center;
      text-align: center;
      width: 100%;
      max-width: none;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 50px;
      background: ${plume.COLORS.PRIMARY_WHITE};
      color: ${plume.COLORS.GREY_SHADE_1};

      &:hover {
        border: none;
      }

      ${plume.styles.copy.Base} {
        margin-right: 0px;
        font-size: 10px;
        color: gray;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        display: inline-block;
        min-width: 52px;
      }
    }

    ${plume.styles.select.Label} {
      white-space: initial;
      margin-right: 0;
    }

    ${plume.styles.select.Drawer} {
      pointer-events: all;
      margin: 0;
      width: 100%;
      height: 100%;
      position: relative;
      margin-top: 32px;
    }

    ${plume.styles.select.ScrollList} {
      width: 100%;
    }

    ${plume.styles.option.Label} {
      ${plume.styles.copy._mediumStyle}
    }

    ${plume.styles.dropdown.Dropdown} {
      margin: 0;
      width: 100%;
      height: 100%;
    }

    ${plume.styles.select.CaretDown} {
      display: none;
    }
  }
`

const SortWrapper = styled.div<{ hasSelection: boolean }>`
  z-index: 1;

  @media not screen and ${plume.BREAKPOINTS.TABLET} {
    flex: 1;
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    display: flex;
    align-items: center;
  }
`
